module.exports = __webpack_public_path__ + "static/hero-bg-desktop-8d2df5452117f373a0d655ebf4ee5f74.jpg";